/*
 * @Author: changcheng
 * @LastEditTime: 2023-08-02 14:59:52
 */
import React, { useEffect, FC } from "react";
import { connect } from "react-redux";

import "./index.less";
import { Button, Form, Input, message } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Link, withRouter } from "react-router-dom";

import Base64 from "base-64";
import axios from "@/axios/axios";
import { useGetRandomCode } from "@/hook/randomCode";
import * as actions from "@/store/actions";

const Login: FC<any> = ({ history, setUserInfo }) => {
  const [randomImgUrl, getRandomImgFn] = useGetRandomCode<string>("");

  const login = async (params: any) => {
    const { data, code, msg }: any = await axios.post(
      "/user/api/ce/user/login",
      params
    );
    if (code !== -1) {
      if (data.needAddBaseInfoFlag === 1) {
        history.push("/UpdateUserInfo");
      } else {
        const userInfo: any = await axios.post("/shop/front/ce/user/info");
        setUserInfo({ userInfo: userInfo.data });
        message.success(`登录成功`);
      }
    } else {
      message.error(msg);
      setUserInfo({ userInfo: "" });
      getRandomImgFn();
    }
  };
  function encode(str: string) {
    // 对字符串进行编码
    var encode = encodeURI(str);
    // 对编码的字符串转化base64
    var base64 = btoa(encode);
    return base64;
  }
  // 触发登录方法
  const onFinish = ({ mobile, password, verifyCode }: any): void => {
    if (mobile && password && verifyCode) {
      login({
        mobile: encode(mobile),
        password: encode(password),
        verifyCode: encode(verifyCode),
      });
    } else {
      message.error("请填写用户名、密码、图形验证码");
    }
  };
  useEffect(() => {
    getRandomImgFn();
  }, []);
  return (
    <div className={"login-module"}>
      <Form name="login-form" onFinish={onFinish}>
        <Form.Item name="mobile">
          <Input
            className={"inputStyle"}
            placeholder="用户名"
            prefix={<UserOutlined style={{ fontSize: "20px" }} />}
            size="large"
          />
        </Form.Item>
        <Form.Item name="password">
          <Input.Password
            className={"inputStyle"}
            placeholder="密码"
            prefix={<LockOutlined style={{ fontSize: "20px" }} />}
            size="large"
          />
        </Form.Item>
        <Form.Item name="verifyCode">
          <Input
            className={"inputStyle"}
            type="input"
            placeholder="请输入图形验证码"
            suffix={
              <img
                src={randomImgUrl}
                alt="code"
                onClick={() => {
                  getRandomImgFn();
                }}
                style={{ width: "87px", height: "30px" }}
              />
            }
          />
        </Form.Item>
        <Form.Item>
          <Button
            className={"inputStyle buttonStyle"}
            block
            htmlType="submit"
            size="large"
            type="primary"
          >
            登录
          </Button>
        </Form.Item>
        <div className={"more"}>
          <Link to="/register">账号注册</Link>
          <Link to="/forgot">找回密码</Link>
        </div>
      </Form>
    </div>
  );
};

export default connect((state) => state, actions)(withRouter(Login));
